import axios from 'axios'
const baseURL = '/.netlify/functions/'

// eslint-disable-next-line new-cap
let Lambda = new axios.create({
  baseURL: baseURL,
  timeout: 6000,
})

export default Lambda
